<article>
  @if (questionForm) {
    <div class="question__header">
      <div class="question__header__badge">{{ question().get('questionId').value }}</div>
      <div #trigger>
        @if (questionTypeConfig[question().get('questionType').value]; as config) {
          <empathy-select-type-button [text]="config.text" [icon]="config.icon" [disabled]="readonly()" (action)="showQuestionTypeSelect()" />
        }
      </div>

      @if (notepadQuestionExcludedRender.includes(question().get('questionType').value)) {
        <div
          class="question__header__warning"
          matTooltip="You will not be able to preview this question while in the notepad. It will be available for preview when the survey has been converted to the editor"
        >
          <fa-icon [icon]="faCircleExclamation" color="warn"></fa-icon>
        </div>
      }

      <div class="question__header__action">
        @if (commentCount() > 0) {
          <button
            mat-icon-button
            class="question__header__action-count"
            [matBadge]="commentCount()"
            (click)="filterComments.emit(question().get('questionId').value)"
          >
            <fa-icon [icon]="faComment"></fa-icon>
          </button>
        }

        @if (canComment()) {
          <button mat-stroked-button (click)="addComment.emit(question().get('questionId').value)">Add Comment</button>
        }

        @if (!readonly()) {
          <button mat-icon-button [title]="'Delete question'" color="warn" class="question__header__action-delete" (click)="onDeleteQuestion()">
            <fa-icon [icon]="faTrashCan"></fa-icon>
          </button>
        }
      </div>

      @if (showChangeQuestionType$()) {
        <ng-template
          cdkConnectedOverlay
          [cdkConnectedOverlayOrigin]="trigger"
          [cdkConnectedOverlayOpen]="showChangeQuestionType$()"
          (overlayOutsideClick)="closeAddQuestionOverlay()"
          (detach)="closeAddQuestionOverlay()"
          cdkConnectedOverlayPush="true"
        >
          <empathy-question-type-select [selected]="questionForm.get('questionType')?.value" (completed)="changeQuestionType($event)" />
        </ng-template>
      }
    </div>
    <form class="question__form" action="" [formGroup]="questionForm">
      <input
        class="question__form__title fs__md"
        type="text"
        placeholder="Type your question here..."
        formControlName="questionText"
        autocomplete="off"
        [readonly]="readonly()"
      />
      @if (question().value.questionType) {
        <ng-container *ngComponentOutlet="questionTypeFormComponent[getQuestionType()]; inputs: { question: question(), disabled: readonly() }"></ng-container>
      }

      <div class="question__form__extra">
        <div class="question__form__extra__header">
          <span class="question__form__extra__header-title fs__sm fw__500"><fa-icon [icon]="faCircleInfo"></fa-icon> Question instructions:</span>
        </div>
        <input
          class="question__form__extra__content fs__md"
          type="text"
          placeholder="Type instructions for survey's participants, e.g.: “Select all that apply”"
          formControlName="instructions"
          [readonly]="readonly()"
        />
      </div>

      <div class="question__form__extra">
        <div class="question__form__extra__header">
          <span class="question__form__extra__header-title fs__sm fw__500"><fa-icon [icon]="faLaptopBinary"></fa-icon> Logic notes:</span>
        </div>
        <input
          class="question__form__extra__content fs__md"
          type="text"
          placeholder="Type the notes related to this question, conditional logic, etc..."
          formControlName="programmerNotes"
          [readonly]="readonly()"
        />
      </div>

      <empathy-flags-form [question]="question()" [questionType]="question().get('questionType').value" [disabled]="readonly()"></empathy-flags-form>
    </form>
  }
</article>
